import React from "react";
import { Link } from "react-router-dom";

export default function EmployeeInstructions() {
  return (
    <div className="container mt-4 mb-5" style={{ maxWidth: 820, textAlign: "left" }}>
      <h3 className="ctitle">Instructions for Employee Registration</h3>

      <div style={{ fontFamily: "Arial, sans-serif", lineHeight: 1.7 }}>

        <h4>For New Registration</h4>
        <p>
          All employees of <strong>Panjab University</strong> (Teaching / Non-Teaching / Retiree /
          Permanent / Contractual / Daily Wages) are required to register themselves on the portal.
        </p>

        <h5>Steps to Register:</h5>
        <ol>
          <li>
            Visit the portal or click{" "}
            <Link to="/employee/new">
              <strong>PU Employee Registration</strong>
            </Link>{" "}
            from the Home page.
          </li>
          <li>Fill in the required details carefully.</li>
          <li>
            Upload your official ID proof{" "}
            <strong>(PDF, PNG, JPG, JPEG — max 200 KB)</strong>.
            Images above 200 KB are auto-compressed.
          </li>
          <li>
            Click the <strong>"Save"</strong> button.
          </li>
          <li>
            Upon success, the message{" "}
            <em>"Registration Successful"</em> will appear on screen.
          </li>
        </ol>

        <hr />

        <h4>Post Registration Instructions</h4>
        <ul>
          <li>
            Your details will be verified by your{" "}
            <strong>Chairperson / Head / Branch Incharge</strong>.
          </li>
          <li>
            Once verified, you will receive an <strong>OTP via SMS</strong> which will serve as
            your initial password.
          </li>
          <li>
            Use your <strong>Mobile Number</strong> as the username and the{" "}
            <strong>OTP</strong> as the password to log in to the Employee Portal.
          </li>
          <li>Change your password immediately after the first login.</li>
          <li>
            Verified users may use the{" "}
            <Link to="/forgot-password">
              <strong>Reset Password</strong>
            </Link>{" "}
            option if they forget their password.
          </li>
          <li>
            You can update your details anytime via{" "}
            <strong>Profile → Edit Profile</strong> after logging in.
          </li>
        </ul>

        <hr />

        <h4>Instructions for Heads / Chairpersons</h4>
        <ol>
          <li>
            Log in to the Employee Portal using your{" "}
            <strong>Mobile Number</strong> as the username.
          </li>
          <li>
            Use the <strong>OTP</strong> (received via SMS) or your previously set password.
          </li>
          <li>
            Click on <strong>"Switch Roles"</strong> to access administrative options.
          </li>
          <li>
            To view registered employees, go to{" "}
            <strong>Employee List</strong>.
          </li>
          <li>
            To verify new registrations, go to{" "}
            <strong>Pending Verifications</strong> and approve them.
          </li>
          <li>
            Once approved, the employee will receive an <strong>OTP via SMS</strong> to access
            their account.
          </li>
        </ol>

        <hr />

        <div className="mt-3">
          <Link to="/employee/new" className="btn btn-primary me-2">
            Register as Employee
          </Link>
          <Link to="/" className="btn btn-outline-secondary">
            Back to Home
          </Link>
        </div>

      </div>
    </div>
  );
}
